import React from 'react';
import QuestionContainer from '../questions/QuestionContainer'

export default (props) => (
  <div className="accordion-content">
    <div className="accordion-content-holder">
      <p className="accordion-sub-caption">ELECTROPHYSIOLOGICAL BASIS OF FIBRILLATIO</p>

      <p className="accordion-text">Atrial and ventricular fibrillation are both based upon
        a re-entrant mechanism, a phenomenon that was first recognised almost 100 years ago
        and initially described by Mines and Garrey. Mines also suggested that conduction block
        was necessary to facilitate re-entry. It was not until the 1950s that Moe and colleagues
        advanced the circus movement theory of re-entry when they suggested the multiple wavelet
        hypothesis of atrial fibrillation (AF).
      </p>
      <p className="accordion-text">This proposed that AF occurred in the presence of inhomogeneous atrial
        tissue. It was postulated that multiple wavelets propagated randomly through the atria. These waves
        of excitation were presumed capable of spreading through the atrial myocardium at a time when some
        of its components had recovered while others remained partially or fully refractory as a result of
        a preceding activation.
      </p>
    </div>

    <div className="accordion-content-holder last">
      <p className="accordion-sub-caption">DEFIBRILLATION WAVEFORMS</p>
      <p className="accordion-sub-caption-desc">Early devices employed both alternating and direct current for
        defibrillation. However, by the 1960s it was apparent that alternating current was more detrimental to
        the heart and direct current has been used in defibrillators since.w7 There are a variety of different waveforms
        in use today </p>
      <p className="accordion-text">Early devices employed both alternating and direct current for defibrillation.
        However, by the 1960s it was apparent that alternating current was more detrimental to the heart and direct
        current has been used in defibrillators since.w7 There are a variety of different waveforms in use today </p>
    </div>
    <div className="question-accordion">
      <QuestionContainer questions={props.questions}/>
    </div>
  </div>
);




// WEBPACK FOOTER //
// ./src/blocks/accordion/AccordionContent.jsx